/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Hide_CredentialsInputs */

const es_components_credentials_permissions_hide_credentials = /** @type {(inputs: Components_Credentials_Permissions_Hide_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar Permisos`)
};

const en_components_credentials_permissions_hide_credentials = /** @type {(inputs: Components_Credentials_Permissions_Hide_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Permissions`)
};

/**
* | output |
* | --- |
* | "Hide Permissions" |
*
* @param {Components_Credentials_Permissions_Hide_CredentialsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_hide_credentials = /** @type {((inputs?: Components_Credentials_Permissions_Hide_CredentialsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Hide_CredentialsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_hide_credentials(inputs)
	return en_components_credentials_permissions_hide_credentials(inputs)
});
export { components_credentials_permissions_hide_credentials as "components.credentials.permissions.hide_credentials" }